import Vue from 'vue'
import VueRouter from 'vue-router'
import Home from '../views/Home.vue'
import store from '../store/index'
import PageNotFound from '../views/PageNotFound.vue'

Vue.use(VueRouter)

  const routes = [
  {
    path: '/',
    name: 'home',
    component: Home,
    beforeEnter: (to, from, next) => {
      store.dispatch('logoutUser')
      next()
    }
  },
  {
    path: '/about',
    name: 'about',
    component: () => import(/* webpackChunkName: "about" */ '../views/About.vue')
  },
  {
    path: '/login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '../views/Login.vue')
  },
  {
    path: '/docs',
    name: 'docs',
    component: () => import(/* webpackChunkName: "docs" */ '../views/Docs.vue'),
    beforeEnter: (to, from, next) => {
      console.log('Token', store.getters.estaAutenticado)
      if (!store.getters.estaAutenticado) next('login')
      else next()
    }
  },
  {
    path: '/colegios/:gestion',
    name: 'colegios',
    component: () => import(/* webpackChunkName: "colegios" */ '../views/Colegios.vue'),
    beforeEnter: (to, from, next) => {
      console.log('Valor de gestion seleccionado', !store.getters.estaNivel1)
      if (!store.getters.estaNivel1) next('docs')
      else next()
    }
  },
  {
    path: '/cursos/:colegio',
    name: 'cursos',
    component: () => import(/* webpackChunkName: "cursos" */ '../views/Cursos.vue'),
    beforeEnter: (to, from, next) => {
      if (!store.getters.estaNivel2) next('docs')
      else next()
    }
  },
  {
    path: '/notas/:curso',
    name: 'notas',
    component: () => import(/* webpackChunkName: "notas" */ '../views/Notas.vue'),
    beforeEnter: (to, from, next) => {
      //console.log('Viene de', from)
      if (!store.getters.estaNivel3) next('docs')
      else next()
    }
  },
  {
    path: '*',
    component: PageNotFound
  }
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

export default router
